import React from "react";
import ButtonFx from "./../../components/common/button-fx";
import PageTagging from "components/common/page-tagging/page-tagging";
import "./cyprus.scss";

const Cyprus = () => {
  const handleVisitWebsite = () => {
    window.location.assign("https://www.mrtraffichire.com/");
  };

  const handleEmailEnquiry = () => {
    const emailAddress = "cyprus@mrtraffichire.com";
    const subject = encodeURIComponent("Cyprus Enquiry");

    window.open(`mailto:${emailAddress}?subject=${subject}`, "_blank");
  };

  return (
    <>
      <PageTagging
        title="Mr Traffic Hire | How Can We Help You?"
        description="Visit Mr Traffic Hire or contact us about Cyprus equipment."
      />

      <main className="cyprus-page">
        <img
          src="/images/cyprus-logo.jpg"
          alt="Mr Traffic Hire Cyprus"
          className="cyprus-logo"
        />
        <section className="cyprus-card" aria-labelledby="cyprus-title">
          <h1 id="cyprus-title">MR TRAFFIC HIRE ΚΥΠΡΟΣ</h1>

          <h2>How can we help you?</h2>

          <p>Select an option below.</p>

          <div className="cyprus-card-actions">
            <ButtonFx
              className="mt-aqua-mini-button cyprus-card-button"
              onClick={handleVisitWebsite}
            >
              Visit Our Website
            </ButtonFx>

            <ButtonFx
              className="mt-aqua-mini-button cyprus-card-button"
              onClick={handleEmailEnquiry}
            >
              Email us about Cyprus equipment
            </ButtonFx>
          </div>
        </section>
      </main>
    </>
  );
};

export default Cyprus;